/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'usb': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<g _fill="#C4FFF9" fill-rule="nonzero"><path pid="0" d="M76 110c6.629 0 12 5.371 12 12s-5.371 12-12 12-12-5.371-12-12 5.371-12 12-12M55 51c4.972 0 9 4.028 9 9s-4.028 9-9 9-9-4.028-9-9 4.028-9 9-9M52 81.25c0 6.25 5.647 10 5.647 10L76 105v-6.25l-15.53-12.5c-2.823-2.5-2.823-6.25-2.823-6.25V70H52v11.25zM93.353 62s0 3.75-2.824 6.25L75 80.75V87l18.353-13.75S99 69.5 99 63.25V52h-5.647v10zM67 34h21l-9.8-18h-1.4z"/><path pid="1" d="M75 113V30h6v83zM87 57V39h18v18z"/></g>'
  }
})
